export default "__VITE_PUBLIC_ASSET__6260d32e__"